import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../common/models/api-response.model';
import { Insight } from '../../../../common/models/insight.model';
import { CreatedRequest } from '../../../../common/models/created-by-me.model';
import { MyInboxService } from '../../../../common/services/my-inbox/my-inbox.service';
import { TenantService } from '../../../../common/services/tenant/tenant.service';
import { EMPLOYEE_ROUTES } from '../../../../common/constants/employee.routing.constants';
import { RequestTypeEnum } from '../../../../common/enums/request-type';
import {
  CreatedTasksAdapter,
  CreatedTasksSort,
  CreatedTasksUiFeatures,
} from './created-tasks.adapter';

@Injectable({ providedIn: 'root' })
export class EmployeeCreatedTasksAdapter implements CreatedTasksAdapter {
  private readonly myInboxService = inject(MyInboxService);
  private readonly tenantService = inject(TenantService);

  readonly uiFeatures: CreatedTasksUiFeatures = {
    showResourceTypeFilter: true,
    showProjectLink: true,
  };

  getTasks(
    page: number,
    perPage: number,
    filter: string,
    sort: CreatedTasksSort,
    search: string,
    additionalFilters?: Record<string, string | string[]>
  ): Observable<ApiResponse<CreatedRequest>> {
    return this.myInboxService.getFlowsCreatedByMe(
      page,
      perPage,
      filter,
      sort,
      search,
      additionalFilters
    );
  }

  getArchiveTasks(
    page: number,
    perPage: number,
    sort: CreatedTasksSort,
    search: string,
    additionalFilters?: Record<string, string | string[]>
  ): Observable<ApiResponse<CreatedRequest>> {
    return this.myInboxService.getFilteredArchive(
      page,
      perPage,
      'created_by_me',
      sort,
      0,
      1,
      search,
      additionalFilters
    );
  }

  getInsights(): Observable<{ data: Insight[] }> {
    return this.myInboxService.getFlowsCreatedByMeInsights();
  }

  exportTasks(form: Record<string, unknown>): Observable<unknown> {
    return this.myInboxService.exportCreatedByMe(form);
  }

  archiveRequest(workflowId: number): Observable<unknown> {
    return this.myInboxService.archiveRequest(workflowId);
  }

  restoreRequest(workflowId: number): Observable<unknown> {
    return this.myInboxService.restoreRequest(workflowId);
  }

  getRequestViewLink(flowId: number): string {
    return this.tenantService.tenantPath(
      `${EMPLOYEE_ROUTES.MY_INBOX.REQUEST}/${RequestTypeEnum.VIEW}/${flowId}`
    );
  }

  getRelatedRequestViewLink(childFlowId: number): string {
    return this.getRequestViewLink(childFlowId);
  }
}
